import { Component, OnInit, ViewChild, OnChanges, OnDestroy, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { Subscription } from 'rxjs';
import { SopDetail } from 'ph-bhp-feature-packages/ph-bhp-feature-package-elearning/lib/Models';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpBarChartComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhpBhpCheckChartExportComponent } from '../php-bhp-check-chart-export/php-bhp-check-chart-export.component';
import { questionTypes, questionTypesMap } from '../ph-bhp-questionTypes.service';
import { PhBhpPdfComplianceMultiFilterCheckComponent } from '../ph-bhp-pdf-compliance-multi-filter-check/ph-bhp-pdf-compliance-multi-filter-check.component';
@Component({
  selector: 'app-hygiene-check-evaluation-overall',
  templateUrl: './hygiene-check-evaluation-overall.component.html',
  styleUrls: ['./hygiene-check-evaluation-overall.component.css']
})
export class HygieneCheckEvaluationOverallComponent implements OnInit, OnChanges, OnDestroy {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  private static readonly INITIAL_FIELDS = [
    { 'field': 'title', 'title': 'CONFIGURE.DESCRIPTION', 'group': '' }
  ];
  reportKey: string = 'OverallComplianceScore';
  pageTitle: string;
  textLegend: string;
  questionTypes: any[];
  questionTypesMap: any[];
  langSubscription: Subscription;
  institutionSubscription: Subscription;
  compareCard;
  tempFilter;
  showCompareCard;
  singleCard;
  data;
  filterDetails = [];
  isDesktop = true;
  isAdjustableHeight = true;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterCheckComponent;
  @ViewChild('exportTag', { static: true }) exportTag: PhpBhpCheckChartExportComponent;
  @ViewChild('multiselect', { static: true }) multiselect: any;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
  initFlag = true;
  sopiDs: Array<any> = [];
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  percentageLegend = "{0}%";
  labels;
  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'GENERAL.ITEMS',
    itemsPerPageLabel: 'GENERAL.ITEMS_PAGE'
  };
  userData: any;
  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;

  sopDetail: SopDetail[];

  userSubscription: Subscription;
  //'5 Moments';
  userID;
  roleId;
  appName = 'Hygiene Check';
  filterIndices: number[] = [0];
  evaluationLoaded: boolean = false;
  originalData: any;
  overallComplianceResponse: any;
  isEvaluationTable: boolean = true;

  multiSelectText: string = '';
  results: any = [];
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  userFilters: any;
  sopFilters: any[] = [];
  questionnaires: { id: string, questionnaireName: string, institutionName: string }[] = [];
  fields: any[] = [...HygieneCheckEvaluationOverallComponent.INITIAL_FIELDS];
  gridData: Array<any>;

  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private filterService: PHBHPFeaturePackageEvaluationFilterService,
    private el: ElementRef) {
    this.questionTypes = questionTypes;
    this.questionTypesMap = questionTypesMap;
    this.textLegend = this.layoutService.translateText("CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE");
    this.appConfig.filterDetails ? this.filterDetails = this.appConfig.filterDetails : this.filterDetails = [];
  }

  private scrollListener: any;
  ngAfterViewInit() {
    this.scrollListener = (event) => {
      const dropdownMenu = event.target as HTMLElement;
      if (dropdownMenu.classList.contains('dropdown-menu')) {
        return;
      }
      this.checkDropdownPositions(event);
    };

    document.addEventListener('scroll', this.scrollListener, true);
  }

  checkDropdownPositions(event) {
    const dropdowns: NodeListOf<HTMLElement> = this.el.nativeElement.querySelectorAll('.dropdown-container-input');
    const scrollTop = event.target.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = window.innerHeight;

    dropdowns.forEach(dropdown => {
      const rect = dropdown.getBoundingClientRect();
      const top = rect.top + scrollTop;
      if (top < scrollTop || top + rect.height > scrollTop + windowHeight) {
        if (dropdown.getAttribute('aria-expanded') === 'true') {
          dropdown.dispatchEvent(new Event('click'));
        }
      }
    });
  }

  ngOnInit(): void {
    this.userID = this.appConfig.userData.userId;
    this.roleId = this.appConfig.userData.roleName.roleId;
    this.userData = this.appConfig.userData;
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        for (let i = 0; i < this.charts.length; i++) {
          let chart = this.charts.get(i);
          chart.chartOptions.valueAxis.title.text = this.textLegend;
        }

        this.pageTitle = this.layoutService.translateText("CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE");
        this.compliance.complianceTitle = this.layoutService.translateText("CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE");
        if (this.userHasFilter) {
          this.evaluate(true);
        } else {
          this.layoutService.showLoader = false;
        }
      }, 1000);
    });

    this.pageTitle = this.layoutService.translateText("CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE");
    this.compliance.complianceTitle = this.layoutService.translateText("CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE");
    this.ngOnChanges();
  }
  selectedQuestionnaires: any[] = [];
  onMultiselectChange(event) {
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }
  resetQuestionnaireFilter() {
    this.selectedQuestionnaires = [];
    this.compliance.selectedQuestionnaires = this.selectedQuestionnaires;
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }
  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.userHasFilter = false;
    if (!this.isUserFilterSetted) {
      this.evaluationService.getQuestionnairesByUserAndCountry(this.appConfig.userData.userId, this.appConfig.userData.country).subscribe((questionnaires: any) => {
        this.questionnaires = questionnaires;
        this.evaluationService.getUserHasCheckEvaluationFilter(this.appConfig.userData.userId, this.reportKey).subscribe((userHasFilter) => {
          this.isUserFilterSetted = true;
          if (this.appConfig.checkGeneralFilter != null) {
            userHasFilter = this.appConfig.checkGeneralFilter;
          }

          if (userHasFilter) {
            if (userHasFilter.questionnaireIds && userHasFilter.questionnaireIds.length > 0) {
              var selectedQuestionnaires = userHasFilter.questionnaireIds.map((id) => {
                var questionnaire = this.questionnaires.find(questionnaire => questionnaire.id == id);
                if (questionnaire) {
                  return {
                    id: questionnaire.id,
                    questionnaireName: questionnaire.questionnaireName,
                    institutionName: questionnaire.institutionName
                  }
                } else {
                  return null;
                }
              });

              this.selectedQuestionnaires = selectedQuestionnaires.filter(res => res != null);
              this.compliance.selectedQuestionnaires = this.selectedQuestionnaires;
            } else {
              this.selectedQuestionnaires = [];
            }

            if (userHasFilter.questionTypes && userHasFilter.questionTypes.length > 0) {
              var questionType = this.questionTypesMap.find(res => res.id.toLowerCase() == userHasFilter.questionTypes[0].toLowerCase());
              if (questionType) {
                this.onQuestionTypeChange(questionType, false);
              } else {
                this.onQuestionTypeChange(0, false);
              }
            } else {
              this.onQuestionTypeChange(0, false);
            }

            this.userHasFilter = true;
            this.userFilters = userHasFilter.filters;
            setTimeout(() => { this.initComponent(); });
          } else {
            this.onQuestionTypeChange(0, false);
            this.userFilters = [];
            this.noDataFound = true;
            this.filters.get(0).showFilter(true);
            this.compliance.resultsLoader.next([{}]);
          }
        }, (error) => { }, () => { this.layoutService.showLoader = false; });
      });
    } else {
      setTimeout(() => { this.initComponent(); });
    }
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
    if (this.institutionSubscription)
      this.institutionSubscription.unsubscribe();
    if (this.scrollListener)
      document.removeEventListener('scroll', this.scrollListener, true);
  }

  initComponent() {
    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }

    if (this.appConfig.userData) {
      for (let i = 0; i < this.charts.length; i++) {
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title = {
          text: this.layoutService.translateText("CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE"),
          font: "9px OpenSans-Regular"
        };
      }

      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = '0';
      this.loadFiltersInfo();
      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);
    }
  }

  evaluate(getResults, initialize?) {
    this.data = {
      filters: [],
      roleId: this.roleId,
      questionnaireIds: this.selectedQuestionnaires.length > 0 ? this.selectedQuestionnaires.map(res => res.id) : [],
      questionTypes: this.selectedQuestionType.id === "all" ? [] : [this.selectedQuestionType.id],
    };

    if (this.data.questionnaireIds && this.data.questionnaireIds.length > 0) {
      this.compliance.selectedQuestionnaires = this.selectedQuestionnaires.map((res) => {
        var questionnaire = this.questionnaires.find(questionnaire => questionnaire.id == res.id);
        return {
          id: questionnaire.id,
          questionnaireName: questionnaire.questionnaireName,
          institutionName: questionnaire.institutionName
        }
      });
    } else {
      this.compliance.selectedQuestionnaires = [
        { questionnaireName: "CHECK.EVALUATION.ALL_QUESTIONNAIRES" }
      ]
    }

    if (this.data.questionTypes && this.data.questionTypes.length > 0) {
      this.compliance.selectedQuestionTypes = [this.selectedQuestionType.questionTypeName];
    } else {
      this.compliance.selectedQuestionTypes = ["CHECK.EVALUATION.ALL_QUESTION_TYPES"];
    }

    if (initialize) {
      this.data.filters = this.userFilters;
    } else {
      this.filters.forEach((filter, index) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0,
          filterName: filter.filterName || this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)
        };

        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filters.push(filterData);
        if (filterData.multiSelectName) {
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.compliance.setFilters(this.filters.toArray());
    this.userHasFilter = true;
    if (getResults == true) {
      this.getCheckOverallCompliance(this.userID, this.data);
    } else if (getResults == false) {
      this.saveCheckOverallDetails(this.userID, this.data)
    }
  }

  async loadFiltersInfo() {
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiselectFilter, filter.multiselectValues, true);
          }
        }
      });
    }, 500);
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.checkGeneralFilter = this.data;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
      this.appConfig.checkGeneralFilter = null;
    }

    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/hygiene-check/statistical']); break;
      case 'quickCommentsAnalysis': this.router.navigate(['evaluation/hygiene-check/quickComments']); break;
      case 'overallComplianceScore': this.router.navigate(['evaluation/hygiene-check/overallCompliance']); break;
      case 'individualAuditDataOverview': this.router.navigate(['evaluation/hygiene-check/individualData']); break;
      default: this.router.navigate(['evaluation/hygiene-check/statistical']); break;
    }
  }

  filterCompare() {
    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(cloneDeep(filters[filters.length - 2])));
      this.layoutService.showLoader = false;
    }, 500);

    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }
  }

  showFilter(cardType) {
    const showFilter = cardType;
    if (showFilter == 'singleCard') {
      this.singleCard = !this.singleCard;
      this.compareCard = false;
    }
    if (showFilter == 'compareCard') {
      this.compareCard = !this.compareCard
      this.singleCard = false;
    }
  }

  cancelFilter() {
    this.singleCard = false;
    this.compareCard = false;
  }

  saveCheckOverallDetails(userID, data) {
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    var selectedSeries = JSON.stringify(Array.from(this.selectedSeries))
    this.data.selectedSeries = selectedSeries;
    this.evaluationService.saveCheckSummarisedDetails(userID, this.isSavedFromEvaluation, this.reportKey, data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
    })
  }

  getCheckOverallCompliance(userID, data) {
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getCheckOverallCompliance(userID, this.isSavedFromEvaluation, this.reportKey, data).subscribe((res: any) => {
      this.originalData = JSON.parse(JSON.stringify(res));
      this.overallComplianceResponse = res;
      this.buildChart(this.overallComplianceResponse);
    })
  }

  setFilterDetails() {
    if (this.filterDetails.length > 0) {
      if (this.filters) {
        this.filterService.setFiltersValue(this.filterDetails, this.filters.toArray());
      }
    }
  }

  createFilterData(userID: number) {
    const defaultFilterData = {
      startDate: new Date(),
      endDate: new Date(),
      instutionIDs: "",
      departmentID: "",
      wardID: "",
      professionalCategoryID: "",
      subprofessionalCategoryID: "",
      countryID: 0
    };

    const filters = this.filters && this.filters.length > 0 ? this.filters.map(filter => {
      let filterData = { ...defaultFilterData, startDate: filter.range.start, endDate: filter.range.end };
      if (this.roleId === 1 && filter.setCountry !== 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      return filter.assignData(filterData);
    }) : [defaultFilterData];

    return {
      filter: filters,
      countryID: 0,
      isBenchMark: true,
      userId: userID,
      isSavedFromEvaluation: true,
      roleId: this.roleId
    };
  }

  updateFilters(filters) {
    this.filterIndices = filters.filter.map((_, index) => index);
    this.filters.toArray().forEach((filterComponent, index) => {
      if (filters.filter[index]) {
        let startDate = new Date(filters.filter[index].startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filters.filter[index].endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        filterComponent.setCountryFilter(filters.filter[index].countryID, filters.filter[index].instutionIDs, filters.filter[index].wardID, true);
        filterComponent.setDepartmentFilter(filters.filter[index].departmentID, true);
        filterComponent.setDepartmentTypeFilter(filters.filter[index].departmentTypeID, true);
        filterComponent.setProfessionalCategory(filters.filter[index].professionalCategoryID, filters.filter[index].subprofessionalCategoryID, true);
      }
    });

    setTimeout(() => {
      this.compliance.setFilters(this.filters.toArray());
    }, 1000);

    if (filters.filter.length >= 2 && this.isDesktop) {
      this.showCompareCard = this.filterIndices.length > 1;
      this.compliance.showCompareCard = this.showCompareCard;
      this.tempFilter = filters;
    }
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      var tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiselectFilter, filter.multiselectValues, true);
          }
        }
      });
    }
  }

  buildChart(res) {
    this.evaluationLoaded = false;
    var colors = [
      "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
    ];

    res = this.adjustResponseForEnvironment(res);
    let chart: PhBhpBarChartComponent;
    this.fields = [...HygieneCheckEvaluationOverallComponent.INITIAL_FIELDS];
    this.results = [];
    const categoryTitle: string = 'DASHBOARD.TOTAL_PERCENT_COMPLIANCE';
    res.forEach(result => {
      if (result.overallComplianceScoreList.length > 0) {
        let id = result.filterType || 'single';
        if (this.results.findIndex(r => r.id === id) === -1) {
          this.results.push({
            id,
            overallComplianceScoreList: [],
            gridData: [],
            fields: [...HygieneCheckEvaluationOverallComponent.INITIAL_FIELDS],
            noDataFound: true
          });
        }
      }
    });

    this.compliance.resultsLoader.next(Object.assign([], this.results));
    // The timeout is necessary to give the chart QueryList time to load the component
    setTimeout(() => {
      let filterCount: number = 0;
      let filterTableCount: number = 0;
      res.forEach((overallCompliance: any, index) => {
        let chartId = overallCompliance.filterType || 'single';
        overallCompliance.filterType = chartId;
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        let data = JSON.parse(JSON.stringify(chart.chartOptions));

        if (!data.setId) {
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        data.series[data.nextIndex] = { data: [], name: [], dataOffset: [], serieIndex: index };
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (overallCompliance.overallComplianceScoreList.length === 1 && overallCompliance.overallComplianceScoreList[0].list.length === 0 && chart.noDataFound) {
          this.noDataFound = true;
          chart.noDataFound = true;
        } else {
          if (overallCompliance.overallComplianceScoreList.length === 2 && overallCompliance.overallComplianceScoreList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        }

        overallCompliance.overallComplianceScoreList.forEach((overallCompliance) => {
          let overallComplianceItem = overallCompliance;
          data.series[data.nextIndex].dataSetId = overallComplianceItem.id;
          overallComplianceItem.list.forEach((item) => {
            if (this.data.questionTypes.length > 0) {
              this.data.questionTypes.forEach((questionTypeId) => {
                var questionType = this.questionTypesMap.find(res => res.id == questionTypeId);
                let title = this.layoutService.translateText(questionType.short);
                if (overallComplianceItem.id >= 0 && overallComplianceItem.name) {
                  title += " - " + this.layoutService.translateText(overallComplianceItem.name);
                }

                if (!data.categoryAxis.categories.includes(title)) {
                  data.categoryAxis.categories.push(title);
                  data.categoryAxis.categoryOffset.push({ id: title, setId: overallCompliance.id });
                }

                switch (questionType.key) {
                  case 'yesNo':
                    let yesNoCompliance = item.yesNoCompliance >= 0 ? item.yesNoCompliance * 100 : "NODATA"
                    data.series[data.nextIndex].data.push(yesNoCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: overallComplianceItem.id, value: yesNoCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: overallComplianceItem.id });
                    break;
                  case 'star':
                    let starCompliance = item.starCompliance >= 0 ? item.starCompliance * 100 : "NODATA"
                    data.series[data.nextIndex].data.push(starCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: overallComplianceItem.id, value: starCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: overallComplianceItem.id });
                    break;
                  case 'score':
                    let scoreCompliance = item.scoreCompliance >= 0 ? item.scoreCompliance * 100 : "NODATA"
                    data.series[data.nextIndex].data.push(scoreCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: overallComplianceItem.id, value: scoreCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: overallComplianceItem.id });
                    break;
                }
              });
            } else {
              var questionType = this.questionTypesMap[0];
              let title = this.layoutService.translateText(questionType.short);
              if (overallComplianceItem.id >= 0 && overallComplianceItem.name) {
                title += " - " + this.layoutService.translateText(overallComplianceItem.name);
              }

              if (!data.categoryAxis.categories.includes(title)) {
                data.categoryAxis.categories.push(title);
                data.categoryAxis.categoryOffset.push({ id: title, setId: overallCompliance.id });
              }

              let allCompliance = item.totalCompliance >= 0 ? item.totalCompliance * 100 : "NODATA"
              data.series[data.nextIndex].data.push(allCompliance);
              data.series[data.nextIndex].dataOffset.push({ id: title, setId: overallComplianceItem.id, value: allCompliance });
              data.seriesIdentifier[data.nextIndex].push({ id: title, setId: overallComplianceItem.id });
            }
          });
        });

        let maxLength = data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }


        filterCount++;
        data.series[data.nextIndex].name = [`${this.data.filters && this.data.filters[data.series[data.nextIndex].serieIndex] ? this.data.filters[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + filterCount}`];
        data.series[data.nextIndex].filterName = [`${this.data.filters && this.data.filters[data.series[data.nextIndex].serieIndex] ? this.data.filters[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + filterCount}`];
        data.series[data.nextIndex].filterNum = filterCount

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        let gridData: any[] = this.results[chartIndex].gridData;
        let fields = this.results[chartIndex].fields;
        gridData = Object.assign([], gridData);
        var questionTypes = this.data.questionTypes.length > 0 ? this.data.questionTypes : [
          this.questionTypesMap.find(res => res.key == 'yesNo').id,
          this.questionTypesMap.find(res => res.key == 'star').id,
          this.questionTypesMap.find(res => res.key == 'score').id
        ];

        overallCompliance.overallComplianceScoreList.forEach((element) => {
          let res2 = element.list;
          let multiName = '';
          let elementId = '';
          if (overallCompliance.filterType && overallCompliance.filterType != 'single') {
            // MULTI FILTERS
            multiName = element.name;
            elementId = element.id;
            if (element.list.length == 0 && element.noData == true) {
              multiName = 'EVALUATION.NO_DATA'
              elementId = 'nodata';
            }
            fields.push(
              { 'field': `column_filter_${filterTableCount + 1}_${elementId}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': `${this.data.filters && this.data.filters[filterTableCount] ? this.data.filters[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`, multiName: multiName },
              { 'field': `column_filter_${filterTableCount + 1}_${elementId}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': `${this.data.filters && this.data.filters[filterTableCount] ? this.data.filters[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`, multiName: multiName },
            );
            res2.forEach((item, i) => {
              if (gridData.length == 0) {
                if (this.data.questionTypes.length == 0) {
                  var totalQuestions = { title: this.layoutService.translateText('CHECK.EVALUATION.TOTAL_COMPLIANCE_RATE') };
                  totalQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.totalCompliance == -1 ? "N/A" : `${(item.totalCompliance * 100).toFixed(2)}%`;
                  totalQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.totalAnswers;
                  gridData.push(totalQuestions);
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'yesNo').id)) {
                  var yesNoQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D') };
                  yesNoQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.yesNoCompliance == -1 ? "N/A" : `${(item.yesNoCompliance * 100).toFixed(2)}%`;
                  yesNoQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.yesNoAnswers;
                  gridData.push(yesNoQuestions);
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'star').id)) {
                  var starQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C') };
                  starQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.starCompliance == -1 ? "N/A" : `${(item.starCompliance * 100).toFixed(2)}%`;
                  starQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.starAnswers;
                  gridData.push(starQuestions);
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'score').id)) {
                  var scaleQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F') };
                  scaleQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.scoreCompliance == -1 ? "N/A" : `${(item.scoreCompliance * 100).toFixed(2)}%`;
                  scaleQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.scoreAnswers;
                  gridData.push(scaleQuestions);
                }
              } else {
                if (this.data.questionTypes.length == 0) {
                  var totalQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('CHECK.EVALUATION.TOTAL_COMPLIANCE_RATE'));
                  if (totalQuestionsIndex != -1) {
                    gridData[totalQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.totalCompliance == -1 ? "N/A" : `${(item.totalCompliance * 100).toFixed(2)}%`;
                    gridData[totalQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.totalAnswers;
                  } else {
                    var totalQuestions = { title: this.layoutService.translateText('CHECK.EVALUATION.TOTAL_COMPLIANCE_RATE') };
                    totalQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.totalCompliance == -1 ? "N/A" : `${(item.totalCompliance * 100).toFixed(2)}%`;
                    totalQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.totalAnswers;
                    gridData.unshift(totalQuestions);
                  }
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'yesNo').id)) {
                  var yesNoQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D'));
                  if (yesNoQuestionsIndex != -1) {
                    gridData[yesNoQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.yesNoCompliance == -1 ? "N/A" : `${(item.yesNoCompliance * 100).toFixed(2)}%`;
                    gridData[yesNoQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.yesNoAnswers;
                  } else {
                    var yesNoQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D') };
                    yesNoQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.yesNoCompliance == -1 ? "N/A" : `${(item.yesNoCompliance * 100).toFixed(2)}%`;
                    yesNoQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.yesNoAnswers;
                    gridData.splice(1, 0, yesNoQuestions);
                  }
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'star').id)) {
                  var starQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C'));
                  if (starQuestionsIndex != -1) {
                    gridData[starQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.starCompliance == -1 ? "N/A" : `${(item.starCompliance * 100).toFixed(2)}%`;
                    gridData[starQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.starAnswers;
                  } else {
                    var starQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C') };
                    starQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.starCompliance == -1 ? "N/A" : `${(item.starCompliance * 100).toFixed(2)}%`;
                    starQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.starAnswers;
                    gridData.splice(2, 0, starQuestions);
                  }
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'score').id)) {
                  var scaleQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F'));
                  if (scaleQuestionsIndex != -1) {
                    gridData[scaleQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.scoreCompliance == -1 ? "N/A" : `${(item.scoreCompliance * 100).toFixed(2)}%`;
                    gridData[scaleQuestionsIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.scoreAnswers;
                  } else {
                    var scaleQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F') };
                    scaleQuestions[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.scoreCompliance == -1 ? "N/A" : `${(item.scoreCompliance * 100).toFixed(2)}%`;
                    scaleQuestions[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.scoreAnswers;
                    gridData.push(scaleQuestions);
                  }
                }
              }
            });
          } else {
            // SIMPLE FILTERS
            fields.push(
              { 'field': `column_filter_${filterTableCount + 1}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': `${this.data.filters && this.data.filters[filterTableCount] ? this.data.filters[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}` },
              { 'field': `column_filter_${filterTableCount + 1}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': `${this.data.filters && this.data.filters[filterTableCount] ? this.data.filters[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}` },
            );
            res2.forEach((item, i) => {
              if (gridData.length == 0) {
                if (this.data.questionTypes.length == 0) {
                  var totalQuestions = { title: this.layoutService.translateText('CHECK.EVALUATION.TOTAL_COMPLIANCE_RATE') };
                  totalQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.totalCompliance == -1 ? "N/A" : `${(item.totalCompliance * 100).toFixed(2)}%`;
                  totalQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.totalAnswers;
                  gridData.push(totalQuestions);
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'yesNo').id)) {
                  var yesNoQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D') };
                  yesNoQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.yesNoCompliance == -1 ? "N/A" : `${(item.yesNoCompliance * 100).toFixed(2)}%`;
                  yesNoQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.yesNoAnswers;
                  gridData.push(yesNoQuestions);
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'star').id)) {
                  var starQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C') };
                  starQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.starCompliance == -1 ? "N/A" : `${(item.starCompliance * 100).toFixed(2)}%`;
                  starQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.starAnswers;
                  gridData.push(starQuestions);
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'score').id)) {
                  var scaleQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F') };
                  scaleQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.scoreCompliance == -1 ? "N/A" : `${(item.scoreCompliance * 100).toFixed(2)}%`;
                  scaleQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.scoreAnswers;
                  gridData.push(scaleQuestions);
                }
              } else {
                if (this.data.questionTypes.length == 0) {
                  var totalQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('CHECK.EVALUATION.TOTAL_COMPLIANCE_RATE'));
                  if (totalQuestionsIndex != -1) {
                    gridData[totalQuestionsIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.totalCompliance == -1 ? "N/A" : `${(item.totalCompliance * 100).toFixed(2)}%`;
                    gridData[totalQuestionsIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.totalAnswers;
                  } else {
                    var totalQuestions = { title: this.layoutService.translateText('CHECK.EVALUATION.TOTAL_COMPLIANCE_RATE') };
                    totalQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.totalCompliance == -1 ? "N/A" : `${(item.totalCompliance * 100).toFixed(2)}%`;
                    totalQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.totalAnswers;
                    gridData.unshift(totalQuestions);
                  }
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'yesNo').id)) {
                  var yesNoQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D'));
                  if (yesNoQuestionsIndex != -1) {
                    gridData[yesNoQuestionsIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.yesNoCompliance == -1 ? "N/A" : `${(item.yesNoCompliance * 100).toFixed(2)}%`;
                    gridData[yesNoQuestionsIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.yesNoAnswers;
                  } else {
                    var yesNoQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D') };
                    yesNoQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.yesNoCompliance == -1 ? "N/A" : `${(item.yesNoCompliance * 100).toFixed(2)}%`;
                    yesNoQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.yesNoAnswers;
                    gridData.splice(1, 0, yesNoQuestions);
                  }
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'star').id)) {
                  var starQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C'));
                  if (starQuestionsIndex != -1) {
                    gridData[starQuestionsIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.starCompliance == -1 ? "N/A" : `${(item.starCompliance * 100).toFixed(2)}%`;
                    gridData[starQuestionsIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.starAnswers;
                  } else {
                    var starQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C') };
                    starQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.starCompliance == -1 ? "N/A" : `${(item.starCompliance * 100).toFixed(2)}%`;
                    starQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.starAnswers;
                    gridData.splice(2, 0, starQuestions);
                  }
                }

                if (questionTypes.includes(this.questionTypesMap.find(res => res.key == 'score').id)) {
                  var scaleQuestionsIndex = gridData.findIndex(res => res.title == this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F'));
                  if (scaleQuestionsIndex != -1) {
                    gridData[scaleQuestionsIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.scoreCompliance == -1 ? "N/A" : `${(item.scoreCompliance * 100).toFixed(2)}%`;
                    gridData[scaleQuestionsIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.scoreAnswers;
                  } else {
                    var scaleQuestions = { title: this.layoutService.translateText('QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F') };
                    scaleQuestions[`column_filter_${filterTableCount + 1}_compliance`] = item.scoreCompliance == -1 ? "N/A" : `${(item.scoreCompliance * 100).toFixed(2)}%`;
                    scaleQuestions[`column_filter_${filterTableCount + 1}_opportunities`] = item.scoreAnswers;
                    gridData.push(scaleQuestions);
                  }
                }
              }
            });
          }

        });


        filterTableCount += 1;
        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].resultChart = chart;

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if (complianceChart) {
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 2, 2);
          this.compliance.setFilters(this.filters.toArray());

          if (index == res.length - 1) {
            this.compliance.resultsLoader.next(cloneDeep(this.results));
            if (this.exportTag) {
              this.exportTag.results = Object.assign([], this.results);
            }
          }

        }, 500);
      });
      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);
    }, 1000);

  }

  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((overallCompliance: any, index) => {
        if (index === 1) {
          spliceCount++;
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });
      return res.splice(idx, spliceCount);
    }
    return res;
  }

  initializeFilters() {
    this.selectedSeries = [];
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });

    this.evaluationService.getHygieneCheckEvaluationSeries(this.userID, this.reportKey).subscribe((seriesData: any) => {
      if (!seriesData || seriesData.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }
      this.selectedSeries = JSON.parse(seriesData.selectedSeries);
      if (this.selectedSeries.length == 0) {
        this.layoutService.showLoader = false;
        return;
      }

      let chartSeries = JSON.parse(seriesData.selectedSeries);
      setTimeout(() => {
        chartSeries.forEach(serie => {
          if (typeof serie === 'number') {
            this.charts.forEach((chart) => {
              this.compliance.toggleVisibility(chart.chartId, { index: serie });
              chart.internalToggleSerie({ index: serie });
            });
          } else {
            let chart = this.charts.find(c => c.chartId === serie.chartId);
            if (!chart) return;
            serie.series.forEach((serie) => {
              chart.internalToggleSerie({ index: serie });
              this.compliance.toggleVisibility(chart.chartId, { index: serie });
            });
            this.filters.forEach((filter, index) => {
              if (index != serie.series) return;
              if (filter.visible == undefined) filter.visible = true;
              filter.visible = !filter.visible;
            });
          }
        });
      }, 1500);
    }, (error) => {
      this.layoutService.showLoader = false;
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetFilters() {
    this.multiselect.reset();
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.onQuestionTypeChange(0, false);
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userID,
      complianceType: this.reportKey,
      selectedSeries: null
    };

    this.evaluationService.updateHygieneCheckEvaluationSeries(seriesData).subscribe(() => {
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });
  }

  updateCheckboxState(momentKey: string, isChecked: boolean) {
    this.layoutService.showLoader = true;
    this.questionTypesMap.find(m => m.key === momentKey).checked = isChecked;
    setTimeout(() => { this.evaluate(true); }, 1000);
  }

  originalFields: any[] = null;
  selectedSeries: any[] = [];

  onSeriesClick(serie: any, resultIndex: number) {
    let chart = this.charts.find(c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId, serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
          .filter(s => s.series.options.visible === false)
          .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: this.reportKey,
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateHygieneCheckEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  trackLoop(index: number, item: any) {
    return item;
  }

  selectedQuestionType: any = { id: "", name: "" };
  onQuestionTypeChange(questionType, evaluate: boolean = true) {
    if (questionType == 0) {
      this.selectedQuestionType = {
        id: "all",
        name: "CHECK.EVALUATION.ALL_QUESTION_TYPES"
      }
    } else {
      this.selectedQuestionType = questionType;
    }

    if (evaluate) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }
}
